export enum PaymentProviderEnum {
  Unspecified = 0,
  InternalTransfer,
  UnknownBank,
  Neteller = 10,
  PaySafe = 20,
  Skrill = 30,
  DSK = 40
}
